/**
 * @generated SignedSource<<ec77bf3f2635403a4d9a43c9c4b52a43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_nativeIssueTable_TeamCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "team_nativeIssueTable_TeamCell";
};
export type team_nativeIssueTable_TeamCell$key = {
  readonly " $data"?: team_nativeIssueTable_TeamCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"team_nativeIssueTable_TeamCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "team_nativeIssueTable_TeamCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "team_issueFieldTeamInlineEditFull_TeamInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraTeamViewField"
};

(node as any).hash = "0c8231e21e67e20de3d4bc8ca26ff0ec";

export default node;
